import { Outlet } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import GlobalSearch from "@/components/GlobalSearch";
import PaywallBanner from "@/components/PaywallBanner";

export default function Layout() {
  return (
    <div className="min-h-screen bg-[#FAF8F5]">
      <Sidebar />
      <main className="md:ml-64">
        <div className="hidden md:flex items-center gap-3 px-6 py-4 bg-white border-b border-[#E8E2D9] sticky top-0 z-10">
          <GlobalSearch />
        </div>
        <div className="p-4 md:p-8 max-w-[1400px] mx-auto space-y-4">
          <PaywallBanner />
          <Outlet />
        </div>
      </main>
    </div>
  );
}
